import React from "react";
//THE ISSUE with the cursor far away: YOU HAVE TO HIDE THE DEFAULT CURSOR
//

const CustomCursor = () => {
  const mainCursor = React.useRef(null);
  // secondaryCursor
  const secondaryCursor = React.useRef(null);

  const positionRef = React.useRef({
    mouseX: 0,
    mouseY: 0,
    destinationX: 0,
    destinationY: 0,
    distanceX: 0,
    distanceY: 0,
    key: -1,
  });

  //

  //the use effect here below serves as a initial update/ ( component did mount)
  React.useEffect(() => {
    document.addEventListener("mousemove", (event) => {
      // x y position in the screen
      const { clientX, clientY } = event;

      const mouseX = clientX;
      const mouseY = clientY;
      //
      //
      //secondaryCursor
      positionRef.current.mouseX =
        mouseX - secondaryCursor.current.clientWidth / 2;
      positionRef.current.mouseY =
        mouseY - secondaryCursor.current.clientHeight / 2;
      //
      mainCursor.current.style.transform = `translate3d(${
        // We want to get the center position of the element. Without subtracting the half of the width we would get the right position of the elemenet.
        // the 2 is for the half of the coordinate of the cursor (- minus half to the x , - minus  half to the Y)
        mouseX - mainCursor.current.clientWidth / 2
      }px, ${mouseY - mainCursor.current.clientHeight / 2}px, 0`;
    });

    return () => {};
  }, []);
  //

  React.useEffect(() => {
    const followMouse = () => {
      //
      positionRef.current.key = requestAnimationFrame(followMouse);
      // below you will take all of the values of the position reference on top
      const {
        mouseX,
        mouseY,
        destinationX,
        destinationY,
        distanceX,
        distanceY,
      } = positionRef.current;

      if (!destinationX | destinationY) {
        positionRef.current.destinationX = mouseX;
        positionRef.current.destinationY = mouseY;
      } else {
        positionRef.current.distanceX = (mouseX - destinationX) * 10; //the animation
        positionRef.current.distanceY = (mouseY - destinationY) * 10;

        // more checkings

        if (
          Math.abs(positionRef.current.distanceX) +
            Math.abs(positionRef.current.distanceY) <
          0.1
        ) {
          positionRef.current.destinationX = mouseX;
          positionRef.current.destinationY = mouseY;
        } else {
          positionRef.current.destinationX += distanceX;
          positionRef.current.destinationY += distanceY;
        }
      }
      //
      secondaryCursor.current.style.transform = `translate3d(${destinationX}px, ${destinationY}px, 0) `;
      //
    };

    // You will need to do some check (If there is "not" destination: do the following)

    //
    //

    followMouse();
  }, []);

  return (
    <React.Fragment>
      <div className="mainCursor" ref={mainCursor}></div>
      <div className="secondaryCursor" ref={secondaryCursor}></div>
    </React.Fragment>
  );
};

export default CustomCursor;

/*
 Simple cursor _ working

import React from "react";

//
// import SliderContentCityMono from "./SliderContent_cityMono";
import HomeDescriptTwoWelcomeImgZoomedMobile2 from "../../img_3d/city-camera.jpg";

const CustomCursor = () => {
  const mainCursor = React.useRef(null);
  //
  //THE ISSUE with the cursor far away: YOU HAVE TO HIDE THE DEFAULT CURSOR
  //the use effect here below serves as a initial update/ ( component did mount)
  React.useEffect(() => {
    document.addEventListener("mousemove", (event) => {
      // x y position in the screen
      const { clientX, clientY } = event;

      const mouseX = clientX;
      const mouseY = clientY;
      //
      mainCursor.current.style.transform = `translate3d(${
        // We want to get the center position of the element. Without subtracting the half of the width we would get the right position of the elemenet.
        // the 2 is for the half of the coordinate of the cursor (- minus half to the x , - minus  half to the Y)
        mouseX - mainCursor.current.clientWidth / 2
      }px, ${mouseY - mainCursor.current.clientHeight / 2}px, 0`;
    });

    return () => {};
  }, []);
  //

  return (
    <React.Fragment>
      <div className="mainCursor" ref={mainCursor}></div>
    </React.Fragment>
  );
};

export default CustomCursor;



.mainCursor {
  z-index: 1000;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  border: 1px solid #111111;
  pointer-events: none;
  overflow: hidden;
  //   the next 4 settings are for superHi totorial
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  position: fixed;
  mix-blend-mode: multiply;
  //
  //   if you add this transition before adding the JS part only
  // as yes the correct way is to do it there, otherwise
  //  you will be getting something slow with just the transition below
  //   transition: all 1s;
}






*/

/*

  <div className="portfolio__Wrapper">
          <div className="portfolio__container">
            <div id="cardBox1">
              <img
                className="img-box-port_card"
                src={HomeDescriptTwoWelcomeImgZoomedMobile2}
                alt="img city mono preview"
              />{" "}
              <div className="ball"></div>
            </div>
          </div>
        </div>



also works

https://stackoverflow.com/questions/61919828/add-and-remove-event-listeners-in-react-with-componentdidmount-and-componentwill

import { render } from "@testing-library/react";
import ReactDOM from "react-dom";
import React, { useRef, Component } from "react";

//
// import SliderContentCityMono from "./SliderContent_cityMono";
import HomeDescriptTwoWelcomeImgZoomedMobile2 from "../../img_3d/city-camera.jpg";

class Portfolio extends React.Component {
  // componentDidMount = () => {
  //   //   console.log("I moved");
  // };

  componentDidMount() {
    document.addEventListener("mousemove", this.customCursorFollow);
  }

  componentWillUnmount() {
    document.removeEventListener("mousemove", this.customCursorFollow);
  }

  customCursorFollow(e) {
    const cursor = document.querySelector(".ball");
    cursor.setAttribute(
      "style",
      "top: " + e.pageY + "px; left: " + e.pageX + "px;"
    );
  }

  customCursorClick() {
    const cursor = document.querySelector(".ball");
  }

  // document.body.appendChild( renderer.domElement );
  // use ref as a mount point of the Three.js scene instead of the document.body

  //
  //
  render() {
    return (
      <React.Fragment>
        <section id="portfolio">
          <div className="portfolio__Wrapper">
            <div className="portfolio__container">
              <div id="cardBox1">
                <img
                  className="img-box-port_card"
                  src={HomeDescriptTwoWelcomeImgZoomedMobile2}
                  alt="img city mono preview"
                />{" "}
                <div className="ball"></div>
              </div>
            </div>
          </div>
          <p>
            Hello Lorem ipsum dolor sit, amet consectetur{" "}
            <span> adipisicing elit. Doloribus vitae eius</span>
          </p>
        </section>
      </React.Fragment>
    );
  }
}

export default Portfolio;


*/

/*
It works but there is a little issue on the coordinates
, the cursor is far from the ball



import ReactDOM from "react-dom";
import React, { useRef, Component } from "react";

//
// import SliderContentCityMono from "./SliderContent_cityMono";
import HomeDescriptTwoWelcomeImgZoomedMobile2 from "../../img_3d/city-camera.jpg";

class Portfolio extends React.Component {
 
  state = {
    left: 0,
    top: 0
}


  componentDidMount = () => {

    document.addEventListener('mousemove', (e) => {
      this.setState({left: e.pageX, top: e.pageY});
  });

 
 
  }

  // document.body.appendChild( renderer.domElement );
  // use ref as a mount point of the Three.js scene instead of the document.body

  //
  //
  render() {
    return (
      <React.Fragment>
        <section id="portfolio">
          <div className="portfolio__Wrapper">
            <div className="portfolio__container">
              <div id="cardBox1">
                <img
                  className="img-box-port_card"
                  src={HomeDescriptTwoWelcomeImgZoomedMobile2}
                  alt="img city mono preview"
                />{" "}
                <div className="ball" style={{left: this.state.left, top: this.state.top}}></div>
              </div>
            </div>
          </div>
          <p>
            Hello Lorem ipsum dolor sit, amet consectetur{" "}
            <span> adipisicing elit. Doloribus vitae eius</span>
          </p>
        </section>
      </React.Fragment>
    );
  }
}

export default Portfolio;


*/

/*
https://css-tricks.com/working-with-refs-in-react/

https://reactjs.org/docs/refs-and-the-dom.html


NOT ERROR ANYMORE but not working

import { render } from "@testing-library/react";
import ReactDOM from "react-dom";
import React, { useRef, Component } from "react";

//
// import SliderContentCityMono from "./SliderContent_cityMono";
import HomeDescriptTwoWelcomeImgZoomedMobile2 from "../../img_3d/city-camera.jpg";

class Portfolio extends React.Component {
  //
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.focusTextInput = this.focusTextInput.bind(this);
  }

  focusTextInput() {
    this.myRef.addEventListener("mousemove", (event) => {
      const mouseX = event.pageX;
      const mouseY = event.pageY;

      const ball = this.myRef.querySelector("div.ball");
      ball.style.left = mouseX + "px";

      console.log("I moved");
    });
    // Explicitly focus the text input using the raw DOM API
    // Note: we're accessing "current" to get the DOM node
    this.myRef.current.focus();
  }

  // document.body.appendChild( renderer.domElement );
  // use ref as a mount point of the Three.js scene instead of the document.body

  //
  //
  render() {
    return (
      <React.Fragment>
        <section id="portfolio">
          <div className="portfolio__Wrapper">
            <div className="portfolio__container">
              <div id="cardBox1">
                <img
                  className="img-box-port_card"
                  src={HomeDescriptTwoWelcomeImgZoomedMobile2}
                  alt="img city mono preview"
                />{" "}
                <div className="ball" ref={(ref) => this.focusTextInput}></div>
              </div>
            </div>
          </div>
          <p>
            Hello Lorem ipsum dolor sit, amet consectetur{" "}
            <span> adipisicing elit. Doloribus vitae eius</span>
          </p>
        </section>
      </React.Fragment>
    );
  }
}

export default Portfolio;




*/

/*

   this.myRef.addEventListener("mousemove", function (event) {
      const mouseX = event.pageX;
      const mouseY = event.pageY;

      const ball = this.myRef.querySelector("div.ball");
      ball.style.left = mouseX + "px";

      console.log("I moved");
    });





import React, { useRef } from "react";

//
// import SliderContentCityMono from "./SliderContent_cityMono";
import HomeDescriptTwoWelcomeImgZoomedMobile2 from "../../img_3d/city-camera.jpg";

const Portfolio = () => {
  //

  // document.body.appendChild( renderer.domElement );
  // use ref as a mount point of the Three.js scene instead of the document.body
  const bbh = useRef();

  bbh.addEventListener("mousemove", (event) => {
    const mouseX = event.pageX;
    const mouseY = event.pageY;

    const ball = bbh.querySelector("div.ball");
    ball.style.left = mouseX + "px";

    console.log("I moved");
  });

  //
  //

  return (
    <React.Fragment>
      <section id="portfolio">
        <div className="portfolio__Wrapper">
          <div className="portfolio__container">
            <div id="cardBox1">
              <img
                className="img-box-port_card"
                src={HomeDescriptTwoWelcomeImgZoomedMobile2}
                alt="img city mono preview"
              />{" "}
              <div className="ball" ref={bbh}></div>
            </div>
          </div>
        </div>
        <p>
          Hello Lorem ipsum dolor sit, amet consectetur{" "}
          <span> adipisicing elit. Doloribus vitae eius</span>
        </p>
      </section>
    </React.Fragment>
  );
};

export default Portfolio;



*/
